class scStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.productMainContainer = document.querySelector('.main-product__container');
        this.productInfoWrapper = document.querySelector('.main-product__information-container-wrapper');
        this.scrollButton = this.querySelector('[data-scroll-to-top]');
        this.addToCartButton = this.querySelector('[data-sticky-add-to-bag]');
        this.stickyImage = this.querySelector('[data-sticky-image]');
        this.stickyTitle = this.querySelector('[data-sticky-title]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.isVisible = false;
        this.isUpdating = false;

        this.init();
    }

    init() {
        this.setupScrollListener();
        this.setupAddToCartButton();
        this.setupScrollButton();
        this.setupProductDataSync();
    }

    setupScrollListener() {
        let ticking = false;
        
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });

        this.handleScroll();
    }

    handleScroll() {
        if (this.isUpdating) return;
        
        const productInfoWrapper = document.querySelector('.main-product__information-container-wrapper');
        if (!productInfoWrapper) return;

        const rect = productInfoWrapper.getBoundingClientRect();
        const isVisible = rect.bottom > 0;
        const shouldShow = !isVisible;

        if (shouldShow && !this.isVisible) {
            this.show();
        } else if (!shouldShow && this.isVisible) {
            this.hide();
        }
    }

    show() {
        this.isVisible = true;
        this.classList.add('is-visible');
    }

    hide() {
        this.isVisible = false;
        this.classList.remove('is-visible');
    }

    setupAddToCartButton() {
        if (!this.addToCartButton) return;

        this.addToCartButton.addEventListener('click', () => {
            const originalButton = document.querySelector('product-form button[data-add-to-card-button]');
            if (originalButton) {
                this.addToCartButton.classList.add('is-loading');
                originalButton.click();
                
                setTimeout(() => {
                    this.addToCartButton.classList.remove('is-loading');
                }, 2000);
            }
        });

        const observeOriginalButton = () => {
            const originalButton = document.querySelector('product-form button[data-add-to-card-button]');
            if (!originalButton) return;

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const isOriginalLoading = originalButton.classList.contains('loading');
                        if (isOriginalLoading) {
                            this.addToCartButton.classList.add('is-loading');
                        } else {
                            this.addToCartButton.classList.remove('is-loading');
                        }
                    }
                });
            });

            observer.observe(originalButton, {
                attributes: true,
                attributeFilter: ['class']
            });
        };

        observeOriginalButton();

        const productObserver = new MutationObserver(() => {
            observeOriginalButton();
        });

        if (this.productMainContainer) {
            productObserver.observe(this.productMainContainer, {
                childList: true,
                subtree: true
            });
        }
    }

    setupScrollButton() {
        if (!this.scrollButton) return;

        this.scrollButton.addEventListener('click', () => {
            const productForm = document.querySelector('sc-swatches');
            if (productForm) {
                productForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }

    setupProductDataSync() {
        if (!this.productMainContainer) return;

        const observer = new MutationObserver((mutations) => {
            const hasSignificantChange = mutations.some(mutation => {
                return mutation.type === 'childList' && mutation.addedNodes.length > 0;
            });

            if (hasSignificantChange) {
                this.handleProductChange();
            } else {
                this.updateProductData();
            }
        });

        observer.observe(this.productMainContainer, {
            childList: true,
            subtree: true
        });

        this.updateProductData();
    }

    handleProductChange() {
        this.isUpdating = true;
        this.hide();
        
        setTimeout(() => {
            this.productInfoWrapper = document.querySelector('.main-product__information-container-wrapper');
            this.updateProductData();
            this.isUpdating = false;
            this.handleScroll();
        }, 100);
    }

    updateProductData() {
        const productTitleElement = document.querySelector('.main-product__swatch-name');
        if (productTitleElement && this.stickyTitle) {
            const titleText = productTitleElement.textContent.trim();
            if (titleText && this.stickyTitle.textContent.trim() !== titleText) {
                this.stickyTitle.textContent = titleText;
            }
        }

        const productPriceElement = document.querySelector('.main-product__container .price .money');
        if (productPriceElement && this.stickyPrice) {
            const priceText = productPriceElement.textContent.trim();
            if (priceText && this.stickyPrice.textContent.trim() !== priceText) {
                this.stickyPrice.textContent = priceText;
            }
        }

        const productImageElement = document.querySelector('.main-product__container .product-media img');
        if (productImageElement && this.stickyImage) {
            const imageSrc = productImageElement.src;
            const stickyImg = this.stickyImage.querySelector('img');
            if (stickyImg && imageSrc && stickyImg.src !== imageSrc) {
                stickyImg.src = imageSrc;
                stickyImg.alt = productImageElement.alt;
            }
        }

        const originalButton = document.querySelector('product-form button[data-add-to-card-button]');
        if (originalButton && this.addToCartButton) {
            const isDisabled = originalButton.disabled;
            this.addToCartButton.disabled = isDisabled;
            if (isDisabled) {
                this.addToCartButton.textContent = originalButton.textContent.trim();
            }
        }
    }
}

window.customElements.define('sc-sticky-add-to-cart', scStickyAddToCart);

